import React, { Component } from 'react';
import { connect } from 'react-redux';
import MicroFrontend from './MicroFrontend';

class Home extends Component {
  render() {
    if (this.props.profile && this.props.profile.isFetching === false) {
      return (
        <div>
          <div className="right_content">
            <div className="main_content">
              <MicroFrontend
                history={this.props.history}
                host={process.env.REACT_APP_TELEKARDIA_HOST}
                name="Telekardia"
                userstate={this.props.profile}
                app="telekardia"
              />
            </div>
          </div>
        </div>
      );
    }
    return <div />;
  }
}

const mapStateToProps = state => {
  return {
    profile: state.app.dataSources.me,
  };
};

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/telekardia/components/MicroFrontEndComponent.jsx